import { Text } from '@shopify/polaris';
import { ImageIcon } from '@shopify/polaris-icons';
import { memo } from 'react';
import { ImageStyled, OriginalPrice, PriceGroup, StyledProductCard } from './styled';

interface ProductCardProps {
  image: string;
  title: string;
  quantity: string;
  price: string;
  originalPrice?: string;
}

const ProductCard = ({ image, title, quantity, price, originalPrice }: ProductCardProps) => {
  return (
    <StyledProductCard>
      <div className="item-info">
        <ImageStyled>{image ? <img src={image} alt={title} /> : <ImageIcon />}</ImageStyled>
        <div className="item-name">
          <Text variant="bodyMd" as="p" fontWeight="semibold">
            {title}
          </Text>
          <span>{`x${quantity}`}</span>
        </div>
      </div>
      <PriceGroup>
        {originalPrice && (
          <OriginalPrice>
            <Text variant="bodyMd" as="span" tone="subdued">
              {originalPrice}
            </Text>
          </OriginalPrice>
        )}
        <Text variant="bodyMd" as="p">
          {price}
        </Text>
      </PriceGroup>
    </StyledProductCard>
  );
};

export default memo(ProductCard);
